import React from 'react'
import {FormattedMessage} from 'react-intl'
import styled from '@emotion/styled'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {Text} from '@vio/atlas/Text'
import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'
import {PoweredByInteractive} from '@vio/shared/src/whiteLabel/PoweredBy'

import {useIsRoomsListImprovementsB} from '../hooks/useIsRoomsListImprovementsB'
import {getRoomsSectionTitleVariant} from './getRoomsSectionTitleVariant'

type Props = {
  roomsCount: number
  isCountLoading: boolean
}

const AvailableRoomsNumberSkeleton = styled(SkeletonLoader)`
  display: inline-block;
`

export const RoomsSectionTitle = ({roomsCount, isCountLoading}: Props) => {
  const {isMobile} = useDeviceLayout()
  const {
    commerce: {coBranded, showVioBrandedRoomsTitle}
  } = useBrandCapabilities()
  const isRoomsListImprovementsB = useIsRoomsListImprovementsB()
  const titleVariant = getRoomsSectionTitleVariant({
    showVioBrandedRoomsTitle,
    isCoBranded: coBranded.enabled,
    isRoomsListImprovementsB
  })

  return (
    <>
      {titleVariant === 'bookOnVio' ? (
        <Text variant={isMobile ? 'titleL' : 'titleXL'} dataId="bookOnVioTitle">
          <FormattedMessageWrapper
            id="roomsList.bookVioTitle"
            defaultMessage="Book on Vio.com"
          />
        </Text>
      ) : titleVariant === 'bookOnVioPoweredBy' ? (
        <Box display="flex" alignItems="center" gap="s100">
          <Text variant="titleL" dataId="bookOnVioTitle">
            <FormattedMessageWrapper
              id="roomsList.bookVioTitle"
              defaultMessage="Book on Vio.com"
            />
          </Text>
          <PoweredByInteractive />
        </Box>
      ) : (
        <Text
          variant={showVioBrandedRoomsTitle && !isMobile ? 'titleXL' : 'titleL'}
          dataId="availableRoomsTitle"
        >
          <FormattedMessage
            id="roomsList.availableRoomsHeader"
            defaultMessage="Available rooms ({count})"
            values={{
              // Stable span so Chrome Translate can't break React updates:
              // https://github.com/facebook/react/issues/11538
              count: (
                <span>
                  {isCountLoading ? (
                    <AvailableRoomsNumberSkeleton width={15} />
                  ) : (
                    roomsCount
                  )}
                </span>
              )
            }}
          />
        </Text>
      )}
    </>
  )
}
